<template>
  <!-- G4 + G6: the fields of a follow-up. A task: a date and an optional time. An event: a start and an end. -->
  <div class="follow-up-fields">
    <div class="p-formgrid p-grid">
      <div class="p-field p-col-12 p-md-4">
        <label>Follow-up is a</label>
        <SelectButton id="followUpKind" v-model="form.kind" :options="kinds" optionLabel="label" optionValue="value" @input="kindChanged" />
      </div>
      <div class="p-field p-col-12 p-md-4">
        <label for="followUpType">Type *</label>
        <Dropdown id="followUpType" v-model="form.type" :options="typeOptions" optionLabel="activityTypeName" dataKey="id"
          placeholder="Select type" />
      </div>
      <div class="p-field p-col-12 p-md-4">
        <label for="followUpUser">For</label>
        <Dropdown id="followUpUser" v-model="form.user" :options="users" optionLabel="fullName" dataKey="id"
          :filter="true" placeholder="Select user" />
      </div>
    </div>
    <div class="p-field">
      <label for="followUpSubject">Subject *</label>
      <InputText id="followUpSubject" v-model="form.subject" />
    </div>
    <div class="p-formgrid p-grid">
      <div class="p-field p-col-6 p-md-3">
        <label for="followUpDate">{{ isTask ? 'Date *' : 'Start date *' }}</label>
        <Calendar id="followUpDate" v-model="form.date" dateFormat="dd/mm/yy" :showIcon="true" />
      </div>
      <div class="p-field p-col-6 p-md-3">
        <label for="followUpTime">{{ isTask ? 'Time (optional)' : 'Start time *' }}</label>
        <Calendar id="followUpTime" v-model="form.time" :timeOnly="true" hourFormat="24" :showIcon="true" />
      </div>
      <template v-if="!isTask">
        <div class="p-field p-col-6 p-md-3">
          <label for="followUpEndDate">End date *</label>
          <Calendar id="followUpEndDate" v-model="form.endDate" dateFormat="dd/mm/yy" :showIcon="true" />
        </div>
        <div class="p-field p-col-6 p-md-3">
          <label for="followUpEndTime">End time *</label>
          <Calendar id="followUpEndTime" v-model="form.endTime" :timeOnly="true" hourFormat="24" :showIcon="true" />
        </div>
      </template>
    </div>
    <div class="p-formgrid p-grid">
      <div class="p-field p-col-12 p-md-3">
        <label for="followUpReminder">Email reminder</label>
        <div><InputSwitch id="followUpReminder" v-model="form.reminder" /></div>
      </div>
      <template v-if="form.reminder">
        <div class="p-field p-col-6 p-md-3">
          <label for="followUpReminderDate">Reminder date *</label>
          <Calendar id="followUpReminderDate" v-model="form.reminderDate" dateFormat="dd/mm/yy" :showIcon="true" />
        </div>
        <div class="p-field p-col-6 p-md-3">
          <label for="followUpReminderTime">Reminder time *</label>
          <Calendar id="followUpReminderTime" v-model="form.reminderTime" :timeOnly="true" hourFormat="24" :showIcon="true" />
        </div>
      </template>
    </div>
    <div class="p-field">
      <label for="followUpNotes">Notes</label>
      <Textarea id="followUpNotes" v-model="form.notes" :autoResize="true" rows="3" />
    </div>
    <small v-if="problem" id="followUpProblem" class="p-invalid">{{ problem }}</small>
  </div>
</template>

<script>
import { kindOfType, typesForKind } from '@/mbp/activityKind'

export default {
  name: 'FollowUpFields',
  props: {
    // the form from newFollowUp(); edited in place
    form: { type: Object, required: true },
    types: { type: Array, default: () => [] },
    users: { type: Array, default: () => [] },
    problem: { type: String, default: null }
  },
  data: () => ({
    kinds: [{ label: 'Task', value: 'TASK' }, { label: 'Event', value: 'ACTIVITY' }]
  }),
  computed: {
    typeOptions () {
      return typesForKind(this.types.filter(t => t.active !== false), this.form.kind)
    },
    isTask () {
      return this.form.kind !== 'ACTIVITY'
    }
  },
  methods: {
    // switching Task / Event drops a type of the other kind
    kindChanged () {
      if (this.form.type && kindOfType(this.form.type) !== this.form.kind) this.form.type = null
    }
  }
}
</script>
